import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createErHandoverDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterErHandoverFormSchema } from "./schema";
import { DischargeLetterErHandoverFormSections } from "./sections";

export const getDischargeLetterErHandoverFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ER_HANDOVER
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        admission_medications: value?.admission_medications ?? "",
        admission_reason: value?.admission_reason ?? "",
        allergies: value?.allergies ?? "",
        anamnesis: value?.anamnesis ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        lab_results: value?.lab_results ?? "",
        parameters: value?.parameters ?? "",
        recommendations: value?.recommendations ?? "",
        therapy: value?.therapy ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formErHandover.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf
          .savedFileNameErHandover,
      pdfCreator: createErHandoverDischargeLetterPdf,
    },
    schema: DischargeLetterErHandoverFormSchema,
    sections: DischargeLetterErHandoverFormSections,
  };
};
